import { render, staticRenderFns } from "./AccessToken.vue?vue&type=template&id=ffdf75ea"
import script from "./AccessToken.vue?vue&type=script&lang=js"
export * from "./AccessToken.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports